export const formatDate = (date: string) => {
  const isoDate = new Date(date);
  return (
    `${isoDate.getDate() < 10 ? '0' : ''}` +
    isoDate.getDate() +
    ' / ' +
    `${isoDate.getMonth() < 10 ? '0' : ''}` +
    (isoDate.getMonth() + 1) +
    ' / ' +
    isoDate.getFullYear()
  );
};

export const formatNumber = (number: string | number) =>
  parseFloat(Number(number).toFixed(2));

export const formatPrice = (number: string | number) =>
  Number(number).toFixed(2);
